<template>
  <v-container class="pt-3">
    <v-row>
      <v-col class="pb-0">
        <div class="d-flex mb-6 align-center">
          <div>
            <v-img
              src="/img/enrolment-logo.png"
              width="62"
              height="62"
              contain
              class="flex-shrink-0 flex-grow-0"
            />
          </div>
          <h1 class="ml-4">
            {{ $t("enrolment.pageHeading") }}
          </h1>
        </div>

        <v-card
          elevation="0"
          class="enrolment-card rounded-lg"
          style="position:relative"
        >
          <v-img
            src="/img/enrolment-banner.svg"
            style="background-color:#CBEDFD; min-height: 214px"
            @click="startEnrolment()"
          />
          <v-card-title class="banner-title">
            {{ $t("enrolment.bannerTitle") }}
          </v-card-title>
          <v-card-text class="banner-text">
            {{ $t("enrolment.bannerText") }}
          </v-card-text>
        </v-card>

        <div class="mt-4">
          <v-list>
            <v-subheader class="px-0 success--text">
              {{ $t("enrolment.listHeading") }}
            </v-subheader>
            <v-list-item
              v-for="(learningItem, index) in enrolmentListItems"
              :key="index"
              class="px-0 mb-3"
            >
              <v-card
                @click="handleClick(learningItem)"
                class="px-4 py-3 d-flex flex-grow-1 align-center"
              >
                <div class="mr-6">
                  <v-img
                    :src="learningItem.iconUrl"
                    height="68"
                    width="68"
                  />
                </div>
                <div
                  style="font-size: 18px;"
                  class="font-weight-medium"
                >
                  {{ learningItem.label }}
                </div>
              </v-card>
            </v-list-item>
            <v-list-item
              v-if="validSchools.length"
              class="px-0 mb-3"
            >
              <v-card
                @click="
                  analytics('enrolment', {
                    action: 'button_click',
                    item_category: 'enrolment_type',
                    link_text: 'moving_to_high_school'
                  });
                  movingToHighSchool();
                "
                class="px-4 py-3 d-flex flex-grow-1 align-center"
              >
                <div class="mr-6">
                  <v-img
                    src="/img/moving.svg"
                    height="68"
                    width="68"
                  />
                </div>
                <div
                  style="font-size: 18px;"
                  class="font-weight-medium"
                >
                  Moving to high school
                </div>
              </v-card>
            </v-list-item>
          </v-list>
        </div>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="selectSchool">
      <v-list>
        <v-list-item class="pr-2 py-1">
          <v-list-item-title
            class="d-flex justify-space-between align-start success--text"
          >
            <span
              style="font-size:17px;"
              class="pr-5 mb-3"
            >
              Choose one of your schools to begin a Year 6 to Year 7 transition
              application:
            </span>
            <v-icon
              class="pr-2"
              @click="selectSchool = false"
              size="18"
              color="success"
              style="margin-top: 2px"
            >
              close
            </v-icon>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="(school, i) in validSchools"
          :key="i"
          class="school-card mx-4 mb-2 py-1"
          @click="externalLink(moveToHighSchoolLink(school.schoolCode))"
        >
          <v-list-item-title style="font-size:16px; white-space:normal">
            <div class="d-flex">
              <span class="pr-2">
                <div
                  class="school-logo"
                  :style="`border-color: ${school.details.colour}`"
                >
                  <v-img
                    :src="school.details.logo"
                    height="24px"
                    width="24px"
                  />
                </div>
              </span>
              <span class="d-flex align-center">
                {{ school.details.name }}
              </span>
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import features from "@/features.json";

const Enrolment = {
  name: "Enrolment",
  title: "Enrolment",
  data() {
    return {
      enrolmentItems: [],
      selectSchool: false
    };
  },
  created() {
    window.addEventListener(
      "remoteConfigChanged",
      function() {
        this.enrolmentItems = this.remoteConfig("enrolmentLinks");
      }.bind(this)
    );
  },
  mounted() {
    this.enrolmentItems = this.remoteConfig("enrolmentLinks");
  },
  computed: {
    ...mapGetters(["mySchools"]),
    validSchools: function() {
      return this.mySchools.filter(school => {
        return school.details.campus.some(campus => {
          return (
            campus.years.includes("doe:sws/school/years/all") ||
            campus.years.includes("doe:sws/school/years/year-6")
          );
        });
      });
    },
    enrolmentListItems() {
      return this.enrolmentItems.filter(
        item => item.id !== "moving_to_high_school"
      );
    }
  },
  methods: {
    startEnrolment() {
      //eslint-disable-next-line
      this.externalLink("https://ehub.enrol.education.nsw.gov.au/");
    },
    handleClick(learningItem) {
      this.analytics("enrolment", {
        action: "button_click",
        item_category: "enrolment_type",
        link_text: learningItem.id
      });
      switch (learningItem.id) {
        case "start_a_new_enrolment_application": {
          this.startEnrolment();
          break;
        }
        case "moving_to_high_school": {
          this.movingToHighSchool();
          break;
        }
        default: {
          this.openInApp(learningItem.url, learningItem.label);
          break;
        }
      }
    },
    externalLink(link) {
      //eslint-disable-next-line
      NativeJS.externalLink(link);
    },
    openInApp(link, title) {
      //eslint-disable-next-line
      NativeJS.debugLog(`open ${title}`);
      this.setCookie("deeplinkType", "ENROLMENT", 3650);
      this.setCookie("deeplinkUrl", "ENROLMENT", 3650);
      if (parseInt(this.getCookie("appbuild")) >= features.inAppWebPage) {
        //eslint-disable-next-line
        NativeJS.debugLog("open url");
        //eslint-disable-next-line
        NativeJS.openUrl(
          link,
          JSON.stringify({
            title: title
          })
        );
      } else {
        //eslint-disable-next-line
        NativeJS.externalLink(link);
      }
    },
    movingToHighSchool() {
      if (this.validSchools.length === 1) {
        this.externalLink(
          this.moveToHighSchoolLink(this.validSchools[0].schoolCode)
        );
      } else {
        this.selectSchool = true;
      }
    },
    moveToHighSchoolLink(schoolCode) {
      const link = this.enrolmentItems.find(
        item => item.id === "moving_to_high_school"
      );
      if (link) {
        return link.url.replace("$SCHOOL_CODE", schoolCode);
      } else {
        return null;
      }
    }
  }
};

export default Enrolment;
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.125rem;
}
.v-subheader {
  font-size: 1.125rem;
  font-weight: 500;
}
.v-list-item__title {
  white-space: normal;
}
.school-logo {
  padding: 7px;
  border: 2px solid;
  border-radius: 100px;
  background-color: white;
  margin: 6px 0;
}
.school-card {
  border: 1px solid #407ec9;
  border-radius: 4px;
  &.active {
    background-color: #cbedfd;
  }
}
.banner-title {
  position: absolute;
  left: 20px;
  top: 20px;
  width: 200px;
  padding: 0;
  color: #002664;
  font-size: 2rem;
  font-weight: 700;
  word-break: break-word;
}
.banner-text {
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 200px;
  color: #000 !important;
  font-size: 1.125rem;
  font-weight: 400;
  padding: 0;
}
</style>
